/**
 * Security API
 * Civilization Security API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { RoleDto } from './roleDto';

export interface UserDto { 
    id?: number;
    uuid?: string;
    username?: string;
    name?: string;
    email?: string;
    oauth2Provider?: UserDto.Oauth2ProviderEnum;
    roles?: Array<RoleDto>;
    version?: number;
    lastModifiedDate?: Date;
}
export namespace UserDto {
    export type Oauth2ProviderEnum = 'GitHub' | 'Internal';
    export const Oauth2ProviderEnum = {
        GitHub: 'GitHub' as Oauth2ProviderEnum,
        Internal: 'Internal' as Oauth2ProviderEnum
    };
}